import { render, staticRenderFns } from "./myRamadanListContent.vue?vue&type=template&id=5ebe6b88&scoped=true"
import script from "./myRamadanListContent.vue?vue&type=script&lang=js"
export * from "./myRamadanListContent.vue?vue&type=script&lang=js"
import style0 from "./myRamadanListContent.vue?vue&type=style&index=0&id=5ebe6b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe6b88",
  null
  
)

export default component.exports